import { createContext } from 'react';

export interface UserSession {
  name: string;
  mail: string;
  token: string;
  roles: string[];
}

export interface UserSessionContextState {
  isReady: boolean;
  userSession: UserSession | null;
  login: () => void;
  logout: () => void;
}

export const UserSessionContext = createContext<UserSessionContextState | undefined>(undefined);
